import type { PropsWithChildren } from "react";
import AuthHeader from "@/layouts/auth/auth-header";
import AuthSplitLayoutFormSide from "@/layouts/auth/split-layout/form-side";
import AuthSplitLayoutImageSide from "@/layouts/auth/split-layout/image-side";

type AuthLayoutProps = {
  title?: string;
  description?: string | null;
};

export default function AuthSplitLayout({
  children,
  title,
  description,
}: PropsWithChildren<AuthLayoutProps>) {
  return (
    <div className="relative flex h-dvh flex-col bg-muted">
      <AuthHeader />

      <div className="relative grid h-full grid-cols-1 flex-col items-center justify-center px-8 sm:px-0 lg:max-w-none lg:grid-cols-2 lg:px-0">
        <AuthSplitLayoutFormSide description={description} title={title}>
          {children}
        </AuthSplitLayoutFormSide>
        <AuthSplitLayoutImageSide />
      </div>
    </div>
  );
}
